import { useEffect } from 'react';

export const RESIZE_OBSERVER_ERROR_MESSAGES = [
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications.',
];

/**
 * This hook is used to ignore specific ResizeObserver error messages in the console.
 * It prevents the default behavior of the error event and stops its propagation.
 * Based on discussion in Next.js https://github.com/vercel/next.js/discussions/51551
 * This error can be safely ignored https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
 */
export const useIgnoreResizeObserverError = () => {
  const handleRemoveError = (e: ErrorEvent) => {
    if (RESIZE_OBSERVER_ERROR_MESSAGES.includes(e.message)) {
      // prevent React's listener from firing
      e.stopImmediatePropagation();
      // prevent the browser's console error message
      e.preventDefault();
    }
  };

  useEffect(() => {
    window.addEventListener('error', handleRemoveError);
    return () => {
      window.removeEventListener('error', handleRemoveError);
    };
  }, []);
};
